<template>
  <a :class="cardClasses" :href="post.url">
    <picture class="card__background">
      <img v-if="image" :src="image" :alt="post.title">
    </picture>

    <div v-if="tag" class="tags">
      <Tag variant="-outline">{{ tag }}</Tag>
    </div>

    <div class="card__content">
      <div class="card__header">
        <time v-if="post.date" class="card__date t3">{{ post.date }}</time>
        <h3 class="card__title news-card__title">
          {{ post.title }}
        </h3>
      </div>
      <CmsContent v-if="post.description" class="card__intro t1" :html="post.description" />
    </div>
  </a>
</template>

<script setup lang="ts">
  import { Tag } from '@nuxt-shared/ui/tag';
  import { CmsContent } from '@nuxt-shared/ui/cms-content';
  import { useNewsCardModel } from './model';
  import type { NewsCardProps } from './types';

  const props = withDefaults(defineProps<NewsCardProps>(), { layout: 'default' });
  const { image, tag, cardClasses } = useNewsCardModel(props);
</script>

<style lang="scss" scoped>
  @use './style.scss';
</style>
